import { useSyncExternalStore, useCallback } from 'react';

const STORAGE_KEY = 'koinon_privacy_mode';
const MASK = '••••••';

const listeners = new Set<() => void>();

function getSnapshot(): boolean {
  return localStorage.getItem(STORAGE_KEY) === 'true';
}

function subscribe(cb: () => void) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

function notify() {
  listeners.forEach((cb) => cb());
}

export function usePrivacyMode() {
  const privacyMode = useSyncExternalStore(subscribe, getSnapshot, () => false);

  const togglePrivacyMode = useCallback(() => {
    const next = !getSnapshot();
    localStorage.setItem(STORAGE_KEY, String(next));
    notify();
  }, []);

  const mask = useCallback(
    (value: string | number) => {
      if (!privacyMode) return String(value);
      return MASK;
    },
    [privacyMode]
  );

  return { privacyMode, togglePrivacyMode, mask, MASK } as const;
}
